import {API_URL, apiPost} from '../api'

export const grantBadge = async (badgeId: string, userIds: string[]) => {
    return await apiPost(API_URL, `admin/badges/${badgeId}/grant`, {user_ids: userIds})
}
